// src/components/BrandName.js
// Renders the WasteGame brand name consistently across the app.
// Block (default): stacked THE / WASTEGAME logo — for headings and logo displays.
// Inline: for mentions within body text.
import React from 'react';

const BrandName = ({ inline, style, className }) => {
  if (inline) {
    return (
      <span className={`brand-inline${className ? ' ' + className : ''}`} style={style}>
        WASTE<span className="brand-game">GAME</span>
      </span>
    );
  }
  return (
    <span className={`brand-logo${className ? ' ' + className : ''}`} style={style}>
      <span className="brand-the">THE</span>
      <span className="brand-main">WASTE<span className="brand-game">GAME</span></span>
    </span>
  );
};

export default BrandName;
